import {
  type CombinedOptions,
  type DefaultParamType,
  useTolgee,
  useTranslate,
} from '@tolgee/react';
import { useCallback, useEffect, useState } from 'react';
import { Session } from 'src/state/session';

import { useAuthContext } from 'src/auth/useAuthContext';
import { allLangs, defaultLang } from './config-lang';

const getLangByName = (lang: string) =>
  allLangs.find((_lang) => _lang.value === lang) || defaultLang;

export default function useLocales() {
  const { user, updateSettings, refresh } = useAuthContext();
  const { t: translate } = useTranslate();

  const tolgee = useTolgee();

  const langStorage =
    user?.settings?.language ||
    Session.getItem('defaultLang') ||
    navigator.language ||
    'en';

  const timezoneStorage =
    user?.settings?.timezone ||
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [currentLang, setCurrentLang] = useState(() =>
    getLangByName(langStorage),
  );
  const [currentTimezone, setCurrentTimezone] = useState(timezoneStorage);

  useEffect(() => {
    if (tolgee.getLanguage() !== currentLang.value) {
      tolgee.changeLanguage(currentLang.value);
      Session.setItem('defaultLang', currentLang.value);
    }
  }, [tolgee, currentLang.value]);

  const handleUpdateSettings = useCallback(
    async ({
      language,
      timezone,
    }: { language?: string; timezone?: string }) => {
      language = language || currentLang.value;
      timezone = timezone || currentTimezone;

      await tolgee.changeLanguage(language);

      setCurrentLang(getLangByName(language));
      setCurrentTimezone(timezone);

      Session.setItem('defaultLang', language);

      updateSettings({
        ...user?.settings,
        language,
        timezone,
      });
      await refresh();
    },
    [user, updateSettings, refresh, currentLang, currentTimezone, tolgee],
  );

  //da pra incluir aqui um useEffect se a user.settings.timezone for diferente da do browser que ai notifica e pergunta se deseja atualizar
  // useEffect(() => {
  //   if (user?.settings.timezone !== Intl.DateTimeFormat().resolvedOptions().timeZone) {
  //     alert('Opa parece que você está em uma localização diferente da que você está configurado. Deseja atualizar?');
  //   }
  // }, [user]);

  // useEffect(() => {
  //   if (user) {
  //     handleUpdateSettings({});
  //   }
  // }, [user, handleUpdateSettings]);

  return {
    handleUpdateSettings,
    translate: (text: string, options?: CombinedOptions<DefaultParamType>) =>
      String(translate(text, options)),
    currentLang,
    currentTimezone,
    allLangs,
  };
}
